<!--
	This component defines the inner content of an individual step within a <screen-flow>.
	
	While you can customize your actions below, they will always attempt to move you 
		forward and backward within the flow. Custom actions run *in addition* to this behavior.
-->
<template>
	<section class="screen-flow-content">
		<v-stepper-content :step="index">
			<template v-if="isActive">
				<slot></slot>
			</template>
		</v-stepper-content>
	</section>
</template>

<script>
	export default {
		name: "screenFlowStep",
		props: {
			title: {
				// what should the step node say?
				type: String,
				required: true
			},
			index: {
				type: Number,
				required: true
			},
			selected: {
				type: Boolean,
				default: false
			},
			validate: {
				type: Function,
				required: false,
				default: () => {
					return new Promise( (resolve, reject) => {
						// follow this basic template to validate any page
						let val = true;
						if ( val == true ) {
							// resolution does not need to return any values
							resolve();
						} else {
							// rejection should return an error message
							reject("Please check the page for errors.");
						}
					})
				},
			},
			nextAction: {
				// what function should run when the screen moves forward?
				type: Function,
				required: false,
				default: null,
			},
			prevAction: {
				// what function should run when the screen moves backward?
				type: Function,
				required: false,
				default: null,
			},
			nextText: {
				// what should the forward progress button say?
				type: String,
				required: false,
				default: 'Next'
			},
			prevText: {
				// what should the backward progress button say?
				type: String,
				required: false,
				default: 'Back'
			},
			showFlowActionForward: {
				type: Boolean,
				default: true
			},
			showFlowActionBack: {
				type: Boolean,
				default: true
			},
			showNextDialog: {
				type: Boolean,
				default: false
			},
			showPrevDialog: {
				type: Boolean,
				default: false
			},
			nextDialog: {
				type: Object,
				required: false,
				default() {
					return {
						title: "Before Continuing...",
						executeText: "Continue",
						cancelText: "Cancel",
						content: null,
					}
				}
			},
			prevDialog: {
				type: Object,
				required: false,
				default() {
					return {
						title: "Before Leaving...",
						executeText: "Continue",
						cancelText: "Cancel",
						content: null,
					}
				}
			},
		},
		data() {
			return {
				isActive: false,
			};
		},
		computed: {
			titleID() {
				return this.title.toLowerCase().replace(/ /g, '-');
			}
		},
		mounted() {
			this.isActive = this.selected;
		},
	};
</script>